(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CFP-Main-Content-Section"] && !window.DesignMode) return;
  try {
    


 var productsUrl = '{{collection.url }}/products.json';
  var productIndex = [];
  var colorFilter = false;
  var colors = [];
  $(document).ready(function() {   
 
    // hides the info icon hover popup before the page is loaded
    //$(".hover-container.hover-popup").removeClass("hidden");
    $(".loadFirst").css("display", "block");
    
    // hides the info icon hover popup before the page is loaded
    //$(".hover-container.hover-popup").removeClass("hidden");
    $(".overstock-collection").css("display", "block");
    //hides cateory section if there are no products associated in that category.
   $('.overstock-group p').each(function (){
     if($(this).hasClass('no-product')){
       $(this).parent('.overstock-group').hide();
     }
   })
    // hides the info icon hover popup before the page is loaded
    //$(".hover-container.hover-popup").removeClass("hidden");
    $(".hover-popup").css("display", "block");

    // change the vinyl product variant id & values when color swatch is clicked
    $('.cfp-variantion-color-box-parent > div').click(function(e) { 
        var new_selected_variant_id = $(this).attr('id').replace('select-', '');    
        var old_variant_id = $(this).data('first');
        var new_price_selected = $(this).data('price'); 
        // sets all the color boxes to deselected
        $('.color-box').css("border","1px solid #1C355E");         
        // sets the selected color box to selected
        $('#select-' + new_selected_variant_id).css("border","2px solid #AA2D29");  
        // changes the value of the id on the submit form for add-to-cart
        $('#' + old_variant_id).val(new_selected_variant_id);  
        // changes price to the correct color price 
        $('#price-' + old_variant_id).html(new_price_selected);  
        // changes the variant of the details button to send correct color to details page
        $('#variant-' + old_variant_id).data('variant', new_selected_variant_id);      
    });

    // the details form button directs to the product page!
    $('.details-cfp-btn').click(function() {
     var collection_url_base = $(this).data('collection');
     var product_url_base = $(this).data('product');
     var product_variation_string = $(this).data('variant');
     setTimeout(function() {
     window.location = '/collections/' + collection_url_base + '/products/' + product_url_base + '?variant=' + product_variation_string }, 10);     
    }); 

    // the submit form updates the cart, this passes the form to the cart!
    $('.buy-cfp-btn').click(function() {
     setTimeout(function() {
     window.location = '/cart'}, 600);
    });
    

  var items = [];
  function add(item) {
    Shopify.addItem(item.id, item.quantity, function(e) {
      if (items.length > 0) {
        add(items.shift());
      } else {
        window.location = '/cart';
      }
    });
  }

  function addToCart(element) {
    $('[data-variant-id]:visible').each(function() {
      if ($('input.quantity', $(this)).val() > 0) {
        items.push({ id: $(this).data('variant-id'), quantity: parseInt($('input.quantity', $(this)).val())});
      }
    });
    if (items.length > 0) {
      $(element).html('Redirecting to Cart').attr('disabled', 'disabled');
      add(items.shift());
    } else {
      window.location = '/cart';
    }
  }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
